import posthog from "posthog-js";
import { track } from '@vercel/analytics';


export const logEvent = (event: string) =>  {
  track(event);
  logEventPosthog(event, {});
}

const logEventPosthog = (event: string, properties: any) => {
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || 
     window.location.hostname === '127.0.0.1' ||
     window.location.hostname === '0.0.0.0' ||
     window.location.hostname.includes('.local'));

  if (!isLocalhost) {
    posthog.capture(
      event, 
      properties
    )
  } else {
    console.log('PostHog event skipped (localhost):', event, properties);
  }
}

export default () => { return null; }